import { gql } from '@apollo/client'

export const GetProjectElementsTotalCountQuery = gql`
    query getProjectElementNodesTotalCount(
        $input: GetProjectElementNodeCountInput!
    ) {
        getProjectElementNodesTotalCount(input: $input)
    }
`
